import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

import './style.scss'

const SideBarSkeletonLoading = () => {
  return (
    <div className="SideBarSkeletonLoading Box">
      <div className="SideBarSkeletonLoading__header">
        <div>
          <Skeleton circle={true} width={75} height={75} />
        </div>
        <div style={{ marginTop: '10px' }}>
          <Skeleton />
          <Skeleton />
        </div>
        <Skeleton />
        <Skeleton />
      </div>
      <div className="SideBarSkeletonLoading__body">
        <Skeleton height={125} />
        <Skeleton height={125} />
        <Skeleton height={125} />
        <Skeleton height={125} />
      </div>
    </div>
  )
}

export default SideBarSkeletonLoading
